import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "shield-check",
  "use": "shield-check-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"shield-check\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.166 6.998A11.954 11.954 0 0012 3.943 11.954 11.954 0 0019.834 7C19.944 7.65 20 8.32 20 9c0 5.225-3.34 9.67-8 11.317C7.34 18.67 4 14.224 4 9c0-.682.057-1.35.166-2zm11.541 3.708a1 1 0 00-1.414-1.414L11 12.585l-1.293-1.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol